import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';


@Directive({
    selector: '[removetilde]'
})
export class RemoveTildeDirective {
    constructor(private el: ElementRef, private control: NgControl) {
    }

    @HostListener('input', ['$event']) onEvent($event) {
        const str: string = this.control.value;
        this.control.control.setValue(this.getCleanedString(str));
    }

    private getCleanedString(chain: string): string {
        // Definimos los caracteres que queremos eliminar
        const specialChars = '!@#$^&%*()+=-[]\/{}|:<>?,.';
        // Los eliminamos todos
        for (let i = 0; i < specialChars.length; i++) {
            chain = chain.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
        }
        // Lo queremos devolver limpio en minusculas
        // cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por ' '
        chain = chain.replace(/ /g, ' ');
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        chain = chain.replace(/á/gi, 'a');
        chain = chain.replace(/é/gi, 'e');
        chain = chain.replace(/í/gi, 'i');
        chain = chain.replace(/ó/gi, 'o');
        chain = chain.replace(/ú/gi, 'u');
        chain = chain.replace(/Á/gi, 'A');
        chain = chain.replace(/É/gi, 'E');
        chain = chain.replace(/Í/gi, 'I');
        chain = chain.replace(/Ó/gi, 'O');
        chain = chain.replace(/Ú/gi, 'U');

        chain = chain.replace(/ +(?= )/g, '');
        return chain;
      }
}

@Directive({
    selector: '[uppercase]'
})
export class UpperCaseDirective {
    constructor(private el: ElementRef, private control: NgControl) {
    }

    @HostListener('input', ['$event']) onEvent($event) {
        const str: string = this.control.value;
        this.control.control.setValue(str.toUpperCase());
    }
}

@Directive({
    selector: '[lowercase]'
})
export class LowerCaseDirective {
    constructor(private el: ElementRef, private control: NgControl) {
    }

    @HostListener('input', ['$event']) onEvent($event) {
        const str: string = this.control.value;
        this.control.control.setValue(str.toLowerCase());
    }
}
